export default {"src":"/_next/static/media/logo.710da178.svg","height":44,"width":100,"blurWidth":0,"blurHeight":0};